import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_product_types: { message: "idle" },
};

export const retrieve_product_types_Slice = createSlice({
 name: "retrieve_product_types",
 initialState,
 reducers: {
  success_retrieve_product_types: (state, action) => {
   state.retrieve_product_types = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_product_types: (state, action) => {
   state.retrieve_product_types = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_product_types: (state) => {
   state.retrieve_product_types = { status: app_consts.IDLE };
  },
  loading_retrieve_product_types: (state) => {
   state.retrieve_product_types = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_product_types, fail_retrieve_product_types, reset_retrieve_product_types, loading_retrieve_product_types } = retrieve_product_types_Slice.actions;

export default retrieve_product_types_Slice.reducer;